import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNContactRXImage } from 'src/app/models/cncontactrximage';
import { CNContactRXSerie } from 'src/app/models/cncontactrxserie';

@Component({
  selector: 'app-rx-image-table',
  templateUrl: './rx-image-table.component.html',
  styleUrls: ['./rx-image-table.component.scss']
})
export class RxImageTableComponent implements OnInit {

  @Input() serie: CNContactRXSerie;
  @Output() selected = new EventEmitter<CNContactRXImage>();
  
  displayedColumns: string[] = ['image'];

  constructor() { }

  ngOnInit(): void {
  }

  public thumbnail(image: CNContactRXImage): string {
    return this.serie.baseurl + '/' + image.thumbnail;
  }

  public selectImage(image: CNContactRXImage): void {
    this.selected.emit(image);
  }
}
